import { Theme } from '@mui/material/styles'

import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()((theme: Theme) => ({
  cloudWrapper: {
    width: theme.spacing(21.375),
  },
  rootContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    borderRadius: theme.spacing(1),
    background: theme.palette.text.white,
    boxSizing: 'border-box',
    width: '100%',
    maxWidth: '100%',
    overflow: 'visible',
  },
  heading: {
    fontSize: '18px',
    fontStyle: 'normal',
    fontWeight: 400,
    color: theme.palette.labraText.primary,
    fontFamily: theme.typography.fontFamily,
  },
  subHeading: {
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 500,
    color: theme.palette.labraText.primary,
    fontFamily: theme.typography.fontFamily,
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
    letterSpacing: '0.15px',
    lineHeight: '24px',
    width: '100%',
  },
  keyword: {
    fontWeight: 500,
    display: 'flex',
    gap: theme.spacing(1),
    alignItems: 'center',
  },
  collapsible: {
    transition: 'max-height 0.7s esase-in-out',
    overflow: 'hidden',
    transitionDelay: '0s',
    width: '100%',
  },
  open: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    alignItems: 'flex-start',
    padding: theme.spacing(2, 0),
  },
  closed: {
    maxHeight: '0px',
  },
  description: {
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '20px',
    letterSpacing: '0.25px',
    color: theme.palette.labraText.description,
    fontFamily: theme.typography.fontFamily,
    textAlign: 'left',
  },
  headingContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    alignSelf: 'stretch',
    padding: theme.spacing(0, 4),
    cursor: 'pointer',
  },
  arrowAction: {
    width: '24px',
    height: '32px',
    color: theme.palette.textField.main,
    marginTop: theme.spacing(0.2),
    paddingLeft: theme.spacing(1.3),
    cursor: 'pointer',
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    width: '100%',
    minWidth: 0,
  },
  keywordList: {
    margin: theme.spacing(4, 0),
  },
  responsiveLineWrapper: {
    display: 'flex',
    height: theme.spacing(40),
    width: '100%',
    minWidth: 0,
    overflow: 'visible',
    '& > div': {
      overflow: 'visible',
    },
  },
  legendsWrapper: {
    marginTop: theme.spacing(2.125),
  },
  rightSideHeader: {
    display: 'flex',
    gap: theme.spacing(2),
    alignItems: 'center',
  },
  keywordHeading: {
    fontSize: '12px',
    fontWeight: 400,
    color: theme.palette.labraText.description,
    fontFamily: theme.typography.fontFamily,
    textAlign: 'left',
  },
  rankingBorder: {
    borderBottom: `1px dashed ${theme.palette.dividers.light}`,
  },
  notAvilable: {
    fontSize: '12px',
    fontWeight: 400,
    fontFamily: theme.typography.fontFamily,
    textAlign: 'left',
    lineHeight: '21px',
  },
  overallSearch: {
    display: 'flex',
    gap: theme.spacing(1),
    alignItems: 'center',
    flexShrink: 0,
    whiteSpace: 'nowrap',
  },
  selfRank: {
    fontSize: '24px',
    textAlign: 'end',
  },
  selfRankChange: {
    display: 'flex',
    justifyContent: 'end',
  },
  leftHeadingWrapper: {
    display: 'flex',
    gap: theme.spacing(5),
    alignItems: 'center',
    width: '40%',
    justifyContent: 'space-between',
  },
  rankWrapper: {
    display: 'flex',
    gap: theme.spacing(1.5),
    alignItems: 'center',
  },
  rankSlot: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    flexShrink: 0,
  },
  rankValue: {
    display: 'flex',
    alignItems: 'center',
    lineHeight: '21px',
  },
  rankValueReserved: {
    minWidth: theme.spacing(10),
  },
  rankChangeSlot: {
    display: 'flex',
    alignItems: 'center',
  },
  rankChangeBadge: {
    display: 'flex',
    alignItems: 'center',
  },
  headerRow: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    width: '100%',
    flexWrap: 'nowrap',
  },
  chartRankNote: {
    marginLeft: theme.spacing(2),
    flex: '1 1 0',
    minWidth: 0,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    fontFamily: theme.typography.fontFamily,
    fontSize: '12px',
    fontStyle: 'italic',
    fontWeight: 400,
    lineHeight: '20px',
    letterSpacing: '0.25px',
    color: theme.palette.labraText.secondary,
  },
  placementCenter: {
    display: 'flex',
    alignItems: 'center',
    flexShrink: 0,
  },
  graphWrapper: {
    width: '100%',
    marginTop: theme.spacing(1),
    overflow: 'visible',
  },
  chartScrollContainer: {
    width: '100%',
    overflow: 'visible',
    boxSizing: 'content-box',
    paddingTop: theme.spacing(12),
    marginTop: theme.spacing(-12),
    paddingLeft: theme.spacing(3),
    marginLeft: theme.spacing(-3),
    paddingRight: theme.spacing(3),
    marginRight: theme.spacing(-3),
  },
  chartScrollContainerActive: {
    overflowX: 'auto',
    overflowY: 'hidden',
    WebkitOverflowScrolling: 'touch',
    paddingBottom: theme.spacing(1.5),
  },
  chartFooterNotes: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginTop: theme.spacing(2),
    width: '100%',
    gap: theme.spacing(0.5),
  },
  chartTimeframeLegend: {
    marginTop: 0,
    textAlign: 'center',
    fontFamily: theme.typography.fontFamily,
    fontSize: '12px',
    fontWeight: 400,
    lineHeight: '16px',
    letterSpacing: '0.15px',
    color: theme.palette.labraText.secondary,
    width: '100%',
  },
  axisGroupingControls: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(1.5),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    '& button': {
      cursor: 'default',
    },
    '& button *': {
      cursor: 'default',
    },
  },
  axisGroupingButton: {
    '&&': {
      cursor: 'default',
    },
    '&& *': {
      cursor: 'default',
    },
  },
  chartContent: {
    width: '100%',
    minWidth: 0,
    overflow: 'visible',
  },
  marginTop: {
    marginTop: theme.spacing(2),
    width: '100%',
  },
  toolTip: {
    fontFamily: theme.typography.fontFamily,
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '16px',
    alignSelf: 'stretch',
    textAlign: 'center',
    color: theme.palette.textBackground.main,
  },
}))
